module.exports = __webpack_public_path__ + "img/bandera-estados-unidos.a6e7f6fb.png";